var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "#946952",
  rx: 7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M9 7h6.2l2.1.1a6 6 0 0 1 2 .6 3.7 3.7 0 0 1 2 3.3c0 1-.3 1.7-.9 2.3-.5.6-1.2 1-2 1.3l1.5.5 1.1.8a4 4 0 0 1 1 2.6 3.7 3.7 0 0 1-2 3.5c-.6.4-1.3.6-2 .8l-2.2.2H9zm3.6 6.4V10H16l.8.3.6.5.2.9c0 .3 0 .5-.2.8l-.5.5-.8.3-.8.1zM16 20h-3.3v-3.6h3.8l1 .3.7.5c.2.3.3.6.3 1a1.7 1.7 0 0 1-.8 1.4c-.3.2-.5.3-.8.3z",
  clipRule: "evenodd"
})));
export default SvgSmallLogo;